import {ReactNode} from "react";
import {TbTrashX} from "react-icons/tb";

import {ButtonWithMutationAndConfirmationDialog} from "@/components/ButtonWithMutationAndConfirmationDialog/ButtonWithMutationAndConfirmationDialog.tsx";
import {GQL_CREDENTIAL_DELETE, GQL_CREDENTIALS_QUERY} from "@/lib/queries/credentials.ts";
import {CredentialDeleteResponse} from "@/lib/types/credentials.ts";

interface DeleteCredentialButtonProps {
  dialogTitle: string;
  dialogElement: ReactNode;
  className?: string;
  credentialId: string;
}

export const DeleteCredentialButton = ({
  dialogTitle,
  dialogElement,
  className = "float-end",
  credentialId,
}: DeleteCredentialButtonProps) => {
  return (
    <ButtonWithMutationAndConfirmationDialog<CredentialDeleteResponse>
      dialogTitle={dialogTitle}
      dialogElement={dialogElement}
      mutation_variables={{id: credentialId}}
      mutation_hook_options={{
        refetchQueries: [GQL_CREDENTIALS_QUERY],
      }}
      mutation_GQL={GQL_CREDENTIAL_DELETE}
      className={className}
      dialogType={"delete"}
    >
      <TbTrashX />
    </ButtonWithMutationAndConfirmationDialog>
  );
};
